const theme = {
  token: {
    // COR GERAL
    colorPrimary: "#60b565",
    colorIcon: "#60b565",
    // COR LINK
    colorLink: "#60b565",
    colorLinkHover: "#6cc371",
    colorLinkActive: "#4c8250",
  },
  components: {
    Layout: {
      colorBgHeader: "#60b565",
      colorBgBody: "#e5e5e578",
      paddingHeader: "0 20px",
    },
  },
};

export { theme };
